// Product catalog — The Dripchexk
// 12 pieces live. Each product has a distinct front + back image so the detail
// page can flip between the two views.

const IMG = {
  // Drop 1 — hero photos
  tdcClassicBlack: "https://customer-assets.emergentagent.com/job_streetwear-lab-15/artifacts/lgrr4u0z_IMG_6527.jpeg",
  tdcClassicWhite: "https://customer-assets.emergentagent.com/job_streetwear-lab-15/artifacts/v8jzfyhp_IMG_6521.jpeg",
  tdcPorsche911: "https://customer-assets.emergentagent.com/job_streetwear-lab-15/artifacts/ttk8po0e_IMG_6522.jpeg",
  tdcDontTellMamaBlack: "https://customer-assets.emergentagent.com/job_streetwear-lab-15/artifacts/sqlabq1w_IMG_6525.jpeg",
  tdcDontTellMamaWhite: "https://customer-assets.emergentagent.com/job_streetwear-lab-15/artifacts/z37yngau_IMG_5996.jpeg",
  // Drop 2 — hero photos
  tdcYeahImLostBlack: "https://customer-assets.emergentagent.com/job_streetwear-lab-15/artifacts/c9nxdbqf_IMG_5998.jpeg",
  tdcYeahImLostWhite: "https://customer-assets.emergentagent.com/job_streetwear-lab-15/artifacts/v4u3ffdo_IMG_6632.jpeg",
  tdcPorscheGT3RS: "https://customer-assets.emergentagent.com/job_streetwear-lab-15/artifacts/5wce9lce_IMG_6526.jpeg",
  tdcClassicTee: "https://customer-assets.emergentagent.com/job_streetwear-lab-15/artifacts/d26sq3eg_IMG_5988.jpeg",
  tdcBuildingLegacyTee: "https://customer-assets.emergentagent.com/job_streetwear-lab-15/artifacts/zh2d4kqo_IMG_5991.jpeg",
  // Drop 3 — new pieces
  tdcCokeDietTee: "https://customer-assets.emergentagent.com/job_streetwear-lab-15/artifacts/qtq3z72e_IMG_6631.jpeg",
  tdcNeedMoneyPorscheTee: "https://customer-assets.emergentagent.com/job_streetwear-lab-15/artifacts/1sofsa9f_IMG_6754.jpeg",
  // Companion (second) shots
  plainBlackHoodieFront: "https://customer-assets.emergentagent.com/job_streetwear-lab-15/artifacts/p2jjsp56_IMG_6511.jpeg",
  plainBlackHoodieBack: "https://customer-assets.emergentagent.com/job_streetwear-lab-15/artifacts/13flwm16_IMG_6532.jpeg",
  plainWhiteHoodieFront: "https://customer-assets.emergentagent.com/job_streetwear-lab-15/artifacts/cw20sar9_IMG_6521.jpeg",
  // Additional gallery shots
  classicWhiteHoodieBack: "https://customer-assets.emergentagent.com/job_streetwear-lab-15/artifacts/74aond1e_IMG_6758.jpeg",
  yeahImLostWhiteExtra: "https://customer-assets.emergentagent.com/job_streetwear-lab-15/artifacts/9d7joe46_IMG_6756.jpeg",
  cokeDietTeeExtra: "https://customer-assets.emergentagent.com/job_streetwear-lab-15/artifacts/igv9xobp_IMG_6759.jpeg",
  porscheGT3RSExtra: "https://customer-assets.emergentagent.com/job_streetwear-lab-15/artifacts/seic0quy_IMG_6755.jpeg",
  porsche911Extra: "https://customer-assets.emergentagent.com/job_streetwear-lab-15/artifacts/2ivzu87d_IMG_6508.jpeg",
};

export const PRODUCTS = [
  {
    slug: "tdc-classic-hoodie-black",
    name: "TDC Classic Hoodie (Black)",
    category: "hoodies",
    price: 1300,
    color: "Black",
    description:
      "Heavyweight oversized hoodie in true black. Bold THE DRIP CHEXK. wordmark in pristine white across the chest. Plain back. The one that started the cult.",
    front: IMG.tdcClassicBlack,
    back: IMG.plainBlackHoodieBack,
    bestSeller: true,
  },
  {
    slug: "tdc-classic-hoodie-white",
    name: "TDC Classic Hoodie (White)",
    category: "hoodies",
    price: 1300,
    color: "White",
    description:
      "Heavyweight oversized hoodie in clean broken white. THE DRIP CHEXK. wordmark front print in deep black. Plain back. Everyday luxury.",
    front: IMG.tdcClassicWhite,
    back: IMG.tdcClassicWhite,
  },
  {
    slug: "tdc-porsche-911-hoodie",
    name: "TDC Porsche 911 Hoodie",
    category: "hoodies",
    price: 1300,
    color: "White",
    description:
      "Broken white oversized hoodie with a full editorial Porsche 911 Targa back print — twin pink 911s framed by design-language copy. Plain front. A tribute to the icon.",
    front: IMG.plainWhiteHoodieFront,
    back: IMG.tdcPorsche911,
    extra: [IMG.porsche911Extra],
    showBackFirst: true,
    bestSeller: true,
  },
  {
    slug: "tdc-dont-tell-mama-hoodie-black",
    name: "TDC Don't Tell Mama About Last Night Hoodie (Black)",
    category: "hoodies",
    price: 1300,
    color: "Black",
    description:
      "Midnight black oversized hoodie. Loud hot-pink statement across the back: DONT TELL MAMA ABOUT LAST NIGHT. Plain front. For the nights we're keeping.",
    front: IMG.plainBlackHoodieFront,
    back: IMG.tdcDontTellMamaBlack,
    showBackFirst: true,
    bestSeller: true,
  },
  {
    slug: "tdc-dont-tell-mama-hoodie-white",
    name: "TDC Don't Tell Mama About Last Night Hoodie (White)",
    category: "hoodies",
    price: 1300,
    color: "White",
    description:
      "Clean broken white oversized hoodie. Bold black statement across the back: DONT TELL MAMA ABOUT LAST NIGHT. Plain front.",
    front: IMG.plainWhiteHoodieFront,
    back: IMG.tdcDontTellMamaWhite,
    showBackFirst: true,
  },
  {
    slug: "tdc-yeah-im-lost-hoodie-black",
    name: "TDC Yeah I'm Lost But I Like It (Black)",
    category: "hoodies",
    price: 1300,
    color: "Black",
    description:
      "Midnight black oversized hoodie. Blood-red script across the back: yeah i'm lost but i like it! Plain front. For the ones going the wrong way on purpose.",
    front: IMG.plainBlackHoodieFront,
    back: IMG.tdcYeahImLostBlack,
    showBackFirst: true,
  },
  {
    slug: "tdc-yeah-im-lost-hoodie-white",
    name: "TDC Yeah I'm Lost But I Like It (White)",
    category: "hoodies",
    price: 1300,
    color: "White",
    description:
      "Broken white oversized hoodie. Blood-red script across the back: yeah i'm lost but i like it! Plain front. Wear the wandering.",
    front: IMG.tdcYeahImLostWhite,
    back: IMG.tdcYeahImLostWhite,
    extra: [IMG.yeahImLostWhiteExtra],
  },
  {
    slug: "tdc-porsche-911-gt3-rs-hoodie",
    name: "TDC Porsche 911 GT3 RS",
    category: "hoodies",
    price: 1300,
    color: "Black",
    description:
      "Midnight black oversized hoodie. Clean white technical blueprint of the 911 GT3 RS printed across the back — front + rear + side elevations with real dimensions, plus a colored render of the car. Plain front. Engineered obsession.",
    front: IMG.plainBlackHoodieFront,
    back: IMG.tdcPorscheGT3RS,
    extra: [IMG.porscheGT3RSExtra],
    showBackFirst: true,
    bestSeller: true,
  },
  {
    slug: "tdc-classic-tee-white",
    name: "TDC Classic Tee (White)",
    category: "tees",
    price: 799,
    color: "White",
    description:
      "Clean broken white heavyweight tee. Small THE DRIP CHEXK chest hit in a hand-drawn script. Plain back. Minimal, daily, undeniable.",
    front: IMG.tdcClassicTee,
    back: IMG.tdcClassicTee,
  },
  {
    slug: "tdc-building-legacy-tee",
    name: "TDC Building Legacy Tee",
    category: "tees",
    price: 799,
    color: "White",
    description:
      "Broken white heavyweight tee. Bold black BUILDING A LEGACY back hit in a mixed serif-script cut. Plain front. Wear the work.",
    front: IMG.tdcBuildingLegacyTee,
    back: IMG.tdcBuildingLegacyTee,
    bestSeller: true,
  },
  {
    slug: "tdc-on-a-coke-diet-tee",
    name: "TDC On A Coke Diet Tee",
    category: "tees",
    price: 799,
    color: "Black",
    description:
      "Black heavyweight oversized tee. Front hit reads ON A COKE DIET with a real Diet Coke can floating through the letters. Plain back. The joke is the outfit.",
    front: IMG.tdcCokeDietTee,
    back: IMG.tdcCokeDietTee,
    extra: [IMG.cokeDietTeeExtra],
  },
  {
    slug: "tdc-need-money-for-porsche-tee",
    name: "TDC Need Money For Porsche Tee",
    category: "tees",
    price: 799,
    color: "White",
    description:
      "Broken white heavyweight tee. Loud dripping-graffiti back print: NEED MONEY FOR PORSCHE. Plain front. Say the quiet part out loud.",
    front: IMG.tdcNeedMoneyPorscheTee,
    back: IMG.tdcNeedMoneyPorscheTee,
    bestSeller: true,
  },
];

// Ordered image list for a product: grid-main image first, then the rest, deduped
export const getProductImages = (p) => {
  const ordered = p.showBackFirst ? [p.back, p.front] : [p.front, p.back];
  return [...new Set([...ordered, ...(p.extra || [])])];
};

export const SIZES = ["S", "M", "L", "XL", "XXL"];

export const getProductBySlug = (slug) => PRODUCTS.find((p) => p.slug === slug);
export const getProductsByCategory = (category) =>
  category ? PRODUCTS.filter((p) => p.category === category) : PRODUCTS;
